import React from 'react'
import PropTypes from 'prop-types'

export default class Layer extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    left: PropTypes.number,
    top: PropTypes.number
  }

  static defaultProps = {
    left: 0,
    top: 0
  }

  render() {
    const {className, left, top, children} = this.props
    const style = {
      transform: `translate(${left}px, ${top}px)`
    }

    return <g className={className} style={style}>{children}</g>
  }
}



// WEBPACK FOOTER //
// ./client/components/Chart/Layer.js